import axios from 'axios';
import {BASE_API} from '@app/const/AppSetting';
import { getAuthToken } from './tokenManager'; // Import TokenManager

const instance = axios.create({
    baseURL: BASE_API,
    headers: {
        'content-type': 'application/json'
    }
});

instance.interceptors.request.use(
    (request) => {
        // Use TokenManager instead of direct localStorage
        const accessToken = getAuthToken();
       // console.log('🔍 AXIOS REQUEST - Token from TokenManager:', accessToken ? 'EXISTS' : 'NULL');
      //  console.log('🔍 AXIOS REQUEST - URL:', request.url);

        // Only add Authorization header if token exists
        if (accessToken && accessToken !== 'null' && accessToken !== 'undefined') {
            request.headers.Authorization = `Bearer ${accessToken}`;
         //   console.log('✅ AXIOS REQUEST - Added Authorization header');
        } else {
            // Don't add Authorization header if no valid token
            delete request.headers.Authorization;
         //   console.log('⚠️ AXIOS REQUEST - No valid token, skipped Authorization header');
        }

        // Clean empty string values from request data
        if (request.data) {
            Object.keys(request.data).forEach(key => {
                if (request.data[key] === '') {
                    delete request.data[key];
                }
            });
        }

        return request;
    },
    (error) => {
        console.error('💥 AXIOS REQUEST ERROR:', error);
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (response) => {
       console.log('✅ AXIOS RESPONSE SUCCESS:', {
            url: response.config?.url,
            status: response.status
        });

        // Don't check localStorage here - TokenManager will handle restoration
        console.log('✅ AXIOS RESPONSE - Completed successfully');

        return response;
    },
    (error) => {
       /* console.log('💥 AXIOS RESPONSE ERROR:', {
            url: error.config?.url,
            status: error.response?.status,
            message: error.response?.data?.message
        });*/

        // Don't automatically clear tokens - let components handle auth errors
        //console.log('⚠️ Error occurred but NOT clearing tokens automatically');

        return Promise.reject(error);
    }
);

export default instance;